import { Avatar, Card, CardContent, Grid, Skeleton, Typography } from "@mui/material";
import { AppImageDimension, AppImages } from "app/appImages";
import { MprcContainer, MprcRequestErrorReport, MprcTypographyOnDemand } from "components";
import { MeetingType, TrainingMeetingItemDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from 'react';
import { NIL } from "uuid";
import { ActionButtonMeeting } from "views/lms/student/EnrollmentView/Course/ContentComponents/meeting/TrainingMeetingActions";
import { TrainingMeetingDataBox } from "views/lms/student/EnrollmentView/Course/ContentComponents/meeting/TrainingMeetingDataBox";
import { useEnrollmentViewContext } from "../../..";

interface IProps {
    componentId: string;
    versionNumber?: number;
    classroomId?: string | null;
    enrollmentId?: string;
}

/////////////////////////////////////////////////////////////////////////////////////

export const MeetingContent = (props: IProps) => {

    const { enrollmentId, classroomId, versionNumber, componentId } = props;

    const api = useCoreApi();
    const erlContext = useEnrollmentViewContext();

    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();
    const [reload, setReload] = useState<boolean>(false);
    const [meeting, setMeeting] = useState<TrainingMeetingItemDto>();

    /////////////////////////////////////////////////////////////////////////////////////
    /// EFFECT'S
    /////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        async function getData() {
            try {
                setLoading(true);
                var response;
                if (enrollmentId) {
                    response = await api.v1.enrollment.getMeetingItem({
                        componentId,
                        enrollmentId: enrollmentId == NIL ? null : enrollmentId,
                        classroomId: enrollmentId == NIL ? classroomId ?? null : null
                    });
                }
                else {
                    response = await api.v1.trainingManagement.getMeetingItem({
                        componentId,
                        classroomId: classroomId ?? null,
                        versionNumber: versionNumber ?? null
                    });
                }

                setMeeting(response.data);
            } catch (error) {
                setViewError(error);
            }
            finally {
                setLoading(false);
                setReload(false);
            }
        }

        getData();
    }, [enrollmentId, componentId, reload]);

    ///
    const RenderContent = () => {
        return (
            <>
                {meeting
                    ?
                    <CardContent sx={{ p: 2 }}>
                        <Grid container direction="column" spacing={1}>
                            <Grid>
                                <Typography variant="h5" component="span">
                                    {meeting.name}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Grid container spacing={2} wrap="nowrap">
                                    <Grid>
                                        <Avatar
                                            variant="rounded"
                                            sx={{ width: AppImageDimension.ThumbnailWide.width, height: AppImageDimension.ThumbnailWide.height }}
                                            src={meeting.thumbnailUrl == null
                                                ? AppImages.LmsContentTypeLivePresentialThumbnail
                                                : meeting.thumbnailUrl
                                            }
                                        />
                                    </Grid>
                                    <Grid size="grow">
                                        <TrainingMeetingDataBox meeting={meeting} classroomId={classroomId} enrollment={erlContext?.enrollment} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid>
                                <MprcTypographyOnDemand variant="h6" maxRows={4}>{meeting.description}</MprcTypographyOnDemand>
                            </Grid>
                            {meeting.meetingType != MeetingType.Presential &&
                                <Grid>
                                    <ActionButtonMeeting meeting={meeting} classroomId={classroomId} enrollment={erlContext?.enrollment} onReload={() => setReload(true)} />
                                </Grid>
                            }
                        </Grid>
                    </CardContent>
                    : null
                }
            </>
        );
    };

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {loading
                ? <Skeleton variant="rectangular" width="100%" height={"200px"} />
                :
                viewError
                    ? <MprcRequestErrorReport error={viewError} />
                    : meeting &&
                    <MprcContainer>
                        {enrollmentId
                            ?
                            <Card>
                                {RenderContent()}
                            </Card>
                            :
                            RenderContent()
                        }
                    </MprcContainer>
            }
        </>
    );
};
